export const HIDE_FILTER = [
  "/user-activity",
  "/sku-mapping",
  "/retailer",
  "/retailer-grouping",
  "/document",
  "/uom-mapping",
  "/uom-conversion",
];

export const HIDE_LIST_FILTER = [
  "/synonym",
  "/dashboard",
  "/users",
  "/company",
  "/workflow",
  "/email-listener",
  "/validation",
  "/terminal-key",
  "/user-activity",
  "/settings",
];

export const SUPPORTED_DOCUMENT_LIST = [
  {
    label: ".pdf",
    value: ".pdf",
  },
  {
    label: ".png",
    value: ".png",
  },
  {
    label: ".jpg",
    value: ".jpg",
  },
  {
    label: ".jpeg",
    value: ".jpeg",
  },
  {
    label: ".html",
    value: ".html",
  },
  {
    label: ".htm",
    value: ".htm",
  },
  {
    label: ".mhtml",
    value: ".mhtml",
  },
  {
    label: ".xlsx",
    value: ".xlsx",
  },
  {
    label: ".csv",
    value: ".csv",
  },
  {
    label: ".xls",
    value: ".xls",
  },
  {
    label: ".txt",
    value: ".txt",
  },
  {
    label: ".text",
    value: ".text",
  },
];

export const DATE_TYPES = [
  {
    value: "DD-MM-YYYY",
    label: "DD-MM-YYYY",
  },
  {
    value: "MM-DD-YYYY",
    label: "MM-DD-YYYY",
  },
  {
    value: "YYYY-MM-DD",
    label: "YYYY-MM-DD",
  },
];
